import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { refreshCertification } from '../../utils/certificationCache';
import { IRQCallbacks } from '../../types/my-types';

const useDeleteField = (callbacks?: IRQCallbacks, trainingSetId?: string) => {
  const glynt = useGlynt();
  const cache = useQueryClient();

  return useMutation({
    mutationFn: async (fieldId: string) => {
      return await (await glynt).fields.del(fieldId);
    },

    ...callbacks,

    onSettled: async (data, error) => {
      // Only on success: a failed delete revoked nothing server-side.
      if (!error) {
        refreshCertification(cache, trainingSetId);
      }
      callbacks?.onSettled?.();
    },
  });
};

export default useDeleteField;
